import { PartenariatsPageLexique } from 'locales/types/containers/partenariatsPage';

export const partenariatsPageLexique: PartenariatsPageLexique = {
    headTitle: 'Partnerships',
    concernedPeriod: 'Concerned period',
};

export default partenariatsPageLexique;
